
// import React, { useState, useEffect } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { Drawer, Box, IconButton, List, ListItem, Button, ListItemButton, ListItemIcon, ListItemText, Divider, Tooltip, Collapse, Toolbar, Typography } from "@mui/material";
// import { ExpandLess, ExpandMore } from "@mui/icons-material";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
// import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import LogoutIcon from "@mui/icons-material/Logout";
// import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
// import WarehouseIcon from '@mui/icons-material/Warehouse';
// import FactoryIcon from '@mui/icons-material/Factory';
// import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
// import EngineeringIcon from '@mui/icons-material/Engineering';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import BarChartIcon from '@mui/icons-material/BarChart';
// import { useTranslation } from "react-i18next";
// import { hasPermission } from "../commonfunctions/CheckAuthenticationParameters";
// import useUserPermissions from "../commonfunctions/useUserPermissions";
// import { hasParentModuleAccess } from "../commonfunctions/CheckAuthenticationParameters";


// const MainSideNavBar = ({ open, collapsed, setCollapsed, drawerWidth, onLogout }) => {


//   // const [collapsed, setCollapsed] = useState(() => JSON.parse(localStorage.getItem("sidebarCollapsed")) || false);
//   const [openMenus, setOpenMenus] = useState({});
//   const navigate = useNavigate();
//   const { t } = useTranslation();

//   const userPermissions = useUserPermissions();
//   const [userID, setUserID] = useState(null);
//   const [companyid, setCompanyid] = useState('');

//   useEffect(() => {
//     const retrievedUserID = localStorage.getItem('userID');
//     if (retrievedUserID) {
//       setUserID(retrievedUserID);
//       setCompanyid(localStorage.getItem('companyid'));
//     }
//   }, []); // Empty dependency array to run only once on mount


//   useEffect(() => {
//     localStorage.setItem("sidebarCollapsed", JSON.stringify(collapsed));
//   }, [collapsed]);

//   const toggleMenu = (title) => {
//     setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
//   };


// const allMenus = [
//   { title: "Dashboard", icon: <HomeOutlinedIcon />, path: "/" }, // Always visible
//   { title: "Master", icon: <PeopleOutlinedIcon />, path: "/master-menu", parentModuleName: 'Master' },
//   { title: "Transactions", icon: <ReceiptOutlinedIcon />, path: "/transaction-menu", parentModuleName: 'Transaction' },
//   { title: "Sales", icon: <MonetizationOnIcon />, path: "/sales-menu", parentModuleName: 'Sales' },
//   { title: "Production", icon: <PrecisionManufacturingIcon />, path: "/production-management", parentModuleName: 'Production' },
//   { title: "Warehouse", icon: <WarehouseIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
//   // { title: "Costing", icon: <MonetizationOnIcon />, path: "/costing-management",  }, // Always visible
//   // { title: "Human resource", icon: <EngineeringIcon />, path: "/human-resource", }, // Always visible
//   // { title: "Store", icon: <ShoppingBagIcon />, path: "/store-management", }, // Always visible
//   // { title: "Bill of Material", icon: <EngineeringIcon />, path: "/bill-of-material", }, // Always visible
//   // { title: "Purchase", icon: <ShoppingBagIcon />, path: "/purchase-management", }, // Always visible
//   //  { title: "Reports", icon: <BarChartIcon />, path: "/report-center" },   
//   // { title: "Company Management", icon: <FactoryIcon />, path: "/company-management" },

// ];

//   const menuItems = allMenus.filter(item => {
//     // If there's no parent_module_id, show it by default (e.g. Dashboard)
//     if (!item.parentModuleName) return true;
//     return hasParentModuleAccess(userPermissions, item.parentModuleName);
//   }); 

//   if (hasPermission(userPermissions, "User Management", "Enabled")) {
//     menuItems.push({
//       title: "User Management",
//       icon: <VerifiedUserIcon />,
//       path: `/UserList/${companyid}`,
//     });
//   }

//   return (

//     <Drawer
//       variant="persistent"
//       anchor="left"
//       open={open}
//       borderRadius="0px"
//       sx={{
//         width: drawerWidth, //drawerWidth,
//         // mt:1,
//         transition: "width 0.3s ease",
//         "& .MuiDrawer-paper": {
//           width: drawerWidth,
//           transition: "width 0.3s ease",
//           backgroundColor: "#1f2a40",
//           color: "#fff",
//           borderRight: "0.25px solid rgba(35, 42, 67, 0.1)",
//           borderRadius: "0px",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           paddingTop: 2,
//           overflow: "hidden",
//           overflowY: "auto", // Ensures scrolling when content exceeds height
//           maxHeight: "100vh", // Prevents overflow beyond viewport height
//           scrollbarWidth: "thin", // For Firefox
//           "&::-webkit-scrollbar": {
//             width: "6px", // Small scrollbar width
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "rgba(255, 255, 255, 0.3)", // Scrollbar thumb color            
//           },
//         },
//       }}
//     >


//       {/* Sidebar Header (Toggle Button) */}
//       <Box
//         sx={{
//           width: "100%",
//           display: "flex",
//           justifyContent: collapsed ? "center" : "space-between",
//           alignItems: "center",
//           paddingX: collapsed ? 0 : 2,
//           paddingY: 1,           
//           mt: 2,
//         }}
//       >
//         {!collapsed && <Typography variant="h6" color={"teal"} fontWeight={"bold"} fontSize={18} > </Typography>}

//       </Box>

//       {/* Menu Items */}
//       <List sx={{ width: "100%", flexGrow: 1 }}>
//         {menuItems.map((item, index) => (
//           <React.Fragment key={index}>
//             <ListItem disablePadding sx={{ justifyContent: collapsed ? "center" : "flex-start" }}>
//               <Tooltip title={t(item.title)} placement="right">
//                 <ListItemButton
//                   onClick={item.submenu ? () => toggleMenu(item.title) : () => navigate(item.path)}
//                   sx={{ borderRadius: "8px", marginX: "1px", "&:hover": { backgroundColor: "#2a2b2e" } }}
//                 >
//                   <ListItemIcon sx={{ color: "#fff", minWidth: "30px" }}>
//                     {React.cloneElement(item.icon, { sx: { fontSize: "20px",justifyContent:'left' } })}
//                   </ListItemIcon>

//                   {!collapsed && (
//                     <ListItemText
//                       primary={t(item.title)}
//                       sx={{
//                         fontSize: "0.9rem", // Adjusted main menu font size
//                         fontWeight: 500,
//                       }}
//                     />
//                   )}
//                   {!collapsed && item.submenu && (openMenus[item.title] ? <ExpandLess /> : <ExpandMore />)}
//                 </ListItemButton>
//               </Tooltip>
//             </ListItem>

//             {/* Submenu Items */}
//             {item.submenu && (
//               <Collapse in={openMenus[item.title]} timeout="auto" unmountOnExit>
//                 <List sx={{ pl: collapsed ? 2 : 4 }}>
//                   {item.submenu.map((subItem, subIndex) => (
//                     <ListItemButton
//                       key={subIndex}
//                       component={Link}
//                       to={subItem.path}
//                       sx={{ borderRadius: "8px", marginX: "1px" }}
//                     >
//                       <ListItemText
//                         primary={t(subItem.title)}
//                         sx={{
//                           fontSize: "0.8rem", // Adjusted submenu font size
//                           fontWeight: 400, // Lighter font weight for submenus
//                           paddingLeft: "8px", // Better alignment
//                         }}
//                       />
//                     </ListItemButton>
//                   ))}
//                 </List>
//               </Collapse>
//             )}
//           </React.Fragment>
//         ))}
//       </List>

//       {/* Divider */}
//       <Divider sx={{ marginY: 1, width: "80%", backgroundColor: "rgba(255, 255, 255, 0.2)" }} />

//       {/* Logout Button */}
//       <List sx={{ width: "100%" }}>
//         <ListItem disablePadding sx={{ justifyContent: collapsed ? "center" : "flex-start" }}>
//           <Tooltip title={t("Logout")} placement="right">
//             <ListItemButton
//               onClick={onLogout}
//               sx={{ borderRadius: "8px", marginX: "1px", "&:hover": { backgroundColor: "#2a2b2e" } }}
//             >
//               <ListItemIcon sx={{ color: "#ff4b5c", minWidth: "40px" }}>
//                 <LogoutIcon />
//               </ListItemIcon>
//               {!collapsed && (
//                 <ListItemText
//                   primary={t("Logout")}
//                   sx={{ fontSize: "0.2rem", fontWeight: 500, color: "#ff4b5c" }}
//                 />
//               )}
//             </ListItemButton>
//           </Tooltip>
//         </ListItem>
//       </List>
//     </Drawer>
//   );
// };

// export default MainSideNavBar;










// ...same imports as before

// const MainSideNavBar = ({ open, collapsed, setCollapsed, drawerWidth, onLogout }) => {
//   const [openMenus, setOpenMenus] = useState({});
//   const navigate = useNavigate();
//   const { t } = useTranslation();
//   const userPermissions = useUserPermissions();
//   const [userID, setUserID] = useState(null);
//   const [companyid, setCompanyid] = useState('');

//   useEffect(() => {
//     const retrievedUserID = localStorage.getItem('userID');
//     if (retrievedUserID) {
//       setUserID(retrievedUserID);
//       setCompanyid(localStorage.getItem('companyid'));
//     }
//   }, []);

//   useEffect(() => {
//     localStorage.setItem("sidebarCollapsed", JSON.stringify(collapsed));
//   }, [collapsed]);

//   const toggleMenu = (title) => {
//     setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
//   };

//   const allMenus = [
//     { title: "Home", icon: <HomeOutlinedIcon />, path: "/" },
//     { title: "Master", icon: <PeopleOutlinedIcon />, path: "/master-menu", parentModuleName: 'Master' },
//     { title: "Transactions", icon: <ReceiptOutlinedIcon />, path: "/transaction-menu", parentModuleName: 'Transaction' },
//     { title: "Sales", icon: <MonetizationOnIcon />, path: "/sales-menu", parentModuleName: 'Sales' },
//     { title: "Production", icon: <PrecisionManufacturingIcon />, path: "/production-management", parentModuleName: 'Production' },
//     { title: "Warehouse", icon: <WarehouseIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
//     { title: "Costing", icon: <MonetizationOnIcon />, path: "/costing-management" },
//     { title: "Human resource", icon: <EngineeringIcon />, path: "/human-resource" },
//     { title: "Store", icon: <ShoppingBagIcon />, path: "/store-management" },
//     { title: "Bill of Material", icon: <EngineeringIcon />, path: "/bill-of-material" },
//     { title: "Purchase", icon: <ShoppingBagIcon />, path: "/purchase-management" },
//     { title: "Company Management", icon: <FactoryIcon />, path: "/company-management" },
//   ];

//   const menuItems = allMenus.filter(item => {
//     if (!item.parentModuleName) return true;
//     return hasParentModuleAccess(userPermissions, item.parentModuleName);
//   });

//   if (hasPermission(userPermissions, "User Management", "Enabled")) {
//     menuItems.push({
//       title: "User Management",
//       icon: <VerifiedUserIcon />,
//       path: `/UserList/${companyid}`,
//     });
//   }

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         [`& .MuiDrawer-paper`]: {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//           backgroundColor: '#1f2a40',
//           color: '#fff',
//           borderRight: "1px solid #333",
//           paddingTop: "50px",
//           overflowY: "auto",
//           scrollbarWidth: "thin",
//           '&::-webkit-scrollbar': {
//             width: "6px",
//           },
//           '&::-webkit-scrollbar-thumb': {
//             backgroundColor: "rgba(255,255,255,0.2)",
//           },
//         },
//       }}
//     >
//       {/* Top Logo or Toggle (if needed) */}
//       <Box sx={{ padding: 1, display: 'flex', justifyContent: 'center' }}>
//         <img src="/logo.svg" alt="Logo" style={{ width: 36, height: 36 }} />
//       </Box>

//       {/* Menu Items */}
//       <List>
//         {menuItems.map((item, index) => (
//           <Tooltip key={index} title={t(item.title)} placement="right" arrow>
//             <ListItem disablePadding>
//               <ListItemButton
//                 onClick={() => navigate(item.path)}
//                 sx={{
//                   mx: 1,
//                   my: 0.5,
//                   borderRadius: "10px",
//                   backgroundColor: window.location.pathname === item.path ? "#2e3b55" : "transparent",
//                   "&:hover": { backgroundColor: "#2e3b55" },
//                   justifyContent: collapsed ? "center" : "flex-start",
//                 }}
//               >
//                 <ListItemIcon sx={{ color: "#fff", minWidth: "40px", justifyContent: "center" }}>
//                   {React.cloneElement(item.icon, { fontSize: "small" })}
//                 </ListItemIcon>
//                 {!collapsed && (
//                   <ListItemText
//                     primary={t(item.title)}
//                     primaryTypographyProps={{
//                       fontSize: "14px",
//                       fontWeight: 500,
//                       color: "#fff",
//                     }}
//                   />
//                 )}
//               </ListItemButton>
//             </ListItem>
//           </Tooltip>
//         ))}
//       </List>

//       <Box sx={{ flexGrow: 1 }} />

//       {/* Logout */}
//       <List>
//         <ListItem disablePadding>
//           <Tooltip title={t("Logout")} placement="right" arrow>
//             <ListItemButton
//               onClick={onLogout}
//               sx={{
//                 mx: 1,
//                 my: 1,
//                 borderRadius: "10px",
//                 backgroundColor: "#ff4b5c1a",
//                 "&:hover": { backgroundColor: "#ff4b5c33" },
//                 justifyContent: collapsed ? "center" : "flex-start",
//               }}
//             >
//               <ListItemIcon sx={{ color: "#ff4b5c", minWidth: "40px", justifyContent: "center" }}>
//                 <LogoutIcon fontSize="small" />
//               </ListItemIcon>
//               {!collapsed && (
//                 <ListItemText
//                   primary={t("Logout")}
//                   primaryTypographyProps={{
//                     fontSize: "14px",
//                     fontWeight: 500,
//                     color: "#ff4b5c",
//                   }}
//                 />
//               )}
//             </ListItemButton>
//           </Tooltip>
//         </ListItem>
//       </List>

//       {/* CRM Teamsapce Footer Placeholder */}
//       <Box sx={{ p: 1 }}>
//         {!collapsed && (
//           <Button
//             variant="contained"
//             size="small"
//             sx={{
//               backgroundColor: "#ffd600",
//               color: "#000",
//               textTransform: "none",
//               fontWeight: 600,
//               width: "100%",
//               borderRadius: 2,
//               fontSize: "12px",
//               "&:hover": {
//                 backgroundColor: "#ffea00",
//               },
//             }}
//           >
//             CRM Teamspace
//           </Button>
//         )}
//       </Box>
//     </Drawer>
//   );
// };

// export default MainSideNavBar;

//label call
// import React, { useState } from "react";
// import {
//   Box,
//   Drawer,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemText,
//   Tooltip,
//   Typography,
// } from "@mui/material";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import AddIcon from "@mui/icons-material/Add";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// export default function MainSideNavBar() {
//   const [activeModule, setActiveModule] = useState("Home");
//   const [contextOpen, setContextOpen] = useState(true);

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Sales", icon: <MonetizationOnIcon /> },
//     { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     { id: "Purchase", icon: <ShoppingBagIcon /> },
//     // Add more as needed
//   ];

//   const contextMenus = {
//     Reports: [
//       "All Reports",
//       "My Reports",
//       "Favorites",
//       "Recently Viewed",
//       "Scheduled Reports",
//       "Recently Deleted",
//       "Account and Contact Reports",
//       "Deal Reports",
//       "Lead Reports",
//       "Campaign Reports",
//       "Product Reports",
//       "Vendor Reports",
//       "Quote Reports",
//       "Sales Order Reports",
//       "Purchase Order Reports",
//       "Invoice Reports",
//       "Sales Metrics Reports",
//       "Email Reports",
//       "Meeting Reports",
//     ],
//     Sales: [
//       "Leads",
//       "Contacts",
//       "Accounts",
//       "Deals",
//       "Tasks",
//       "Quotes",
//       "Sales Orders",
//     ],
//     // Add other modules and their context menus as needed
//   };

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         display: "flex",
//         flexDirection: "row",
//         width: "100%",
//         height: "100vh",
//         overflow: "hidden",
//       }}
//     >
//       {/* Left Icon Bar */}
//       <Box
//         sx={{
//           width: 60,
//           backgroundColor: "#101423",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           paddingTop: 1,
//           color: "#fff",
//           flexShrink: 0,
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => setActiveModule(mod.id)}
//               sx={{
//                 color: activeModule === mod.id ? "#00bcd4" : "#fff",
//                 my: 1,
//               }}
//               size="large"
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}
//       </Box>

//       {/* Right Contextual Menu */}
//       <Box
//         sx={{
//           width: contextOpen ? 280 : 40,
//           backgroundColor: "#1c1e2d",
//           color: "#fff",
//           paddingY: 2,
//           paddingX: contextOpen ? 1 : 0,
//           overflowY: "auto",
//           transition: "width 0.3s ease",
//           display: "flex",
//           flexDirection: "column",
//           flexShrink: 0,
//           borderLeft: "1px solid #2e303d",
//           position: "relative",
//         }}
//       >
//         {/* Collapse/Expand Button */}
//         <IconButton
//           onClick={() => setContextOpen(!contextOpen)}
//           size="small"
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: contextOpen ? 8 : "50%",
//             transform: contextOpen ? "none" : "translateX(50%)",
//             color: "#fff",
//             borderRadius: 1,
//             bgcolor: "rgba(255,255,255,0.1)",
//             "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
//           }}
//           aria-label={contextOpen ? "Collapse menu" : "Expand menu"}
//         >
//           {contextOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
//         </IconButton>

//         {contextOpen && (
//           <>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 px: 1,
//                 mb: 1,
//               }}
//             >
//               <Typography variant="subtitle1" fontWeight="bold">
//                 {activeModule}
//               </Typography>
//               {/* <IconButton size="small" sx={{ color: "#fff" }}>
//                 <AddIcon />
//               </IconButton> */}
//             </Box>

//             {/* Search */}
//             <Box sx={{ px: 1, py: 1 }}>
//               <input
//                 type="text"
//                 placeholder={`Search ${activeModule}`}
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "none",
//                   outline: "none",
//                   backgroundColor: "#2a2b3b",
//                   color: "#fff",
//                 }}
//               />
//             </Box>

//             {/* Menu List */}
//             <List dense>
//               {(contextMenus[activeModule] || []).map((item, idx) => (
//                 <ListItemButton
//                   key={idx}
//                   sx={{
//                     color: "#fff",
//                     fontSize: "0.85rem",
//                     borderRadius: "6px",
//                     "&:hover": {
//                       backgroundColor: "#2e303d",
//                     },
//                   }}
//                 >
//                   <ListItemText primary={item} />
//                 </ListItemButton>
//               ))}
//             </List>
//           </>
//         )}
//       </Box>
//     </Drawer>
//   );
// }


// import React, { useState } from "react";
// import {
//   Box,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemText,
//   Tooltip,
//   Typography,
// } from "@mui/material";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import AddIcon from "@mui/icons-material/Add";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// export default function MainSideNavBar() {
//   const [activeModule, setActiveModule] = useState("Reports");
//   const [contextOpen, setContextOpen] = useState(true);

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Sales", icon: <MonetizationOnIcon /> },
//     { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     { id: "Purchase", icon: <ShoppingBagIcon /> },
//   ];

//   const contextMenus = {
//     Reports: [
//       "All Reports",
//       "My Reports",
//       "Favorites",
//       "Recently Viewed",
//       "Scheduled Reports",
//       "Recently Deleted",
//       "Account and Contact Reports",
//       "Deal Reports",
//       "Lead Reports",
//       "Campaign Reports",
//       "Case and Solution Reports",
//       "Product Reports",
//       "Vendor Reports",
//       "Quote Reports",
//       "Sales Order Reports",
//       "Purchase Order Reports",
//       "Invoice Reports",
//       "Sales Metrics Reports",
//       "Email Reports",
//       "Meeting Reports",
//     ],
//     Sales: ["Leads", "Contacts", "Accounts", "Deals", "Tasks", "Quotes", "Sales Orders"],
//   };

//   return (
//     <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
//       {/* Left Sidebar */}
//       <Box
//         sx={{
//           width: 60,
//           backgroundColor: "#101423",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           pt: 1,
//           color: "#fff",
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => setActiveModule(mod.id)}
//               sx={{
//                 color: activeModule === mod.id ? "#00bcd4" : "#fff",
//                 my: 1,
//               }}
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}
//       </Box>

//       {/* Right Context Panel */}
//       <Box
//         sx={{
//           width: contextOpen ? 1000 : 1000,
//           backgroundColor: "#1c1e2d",
//           color: "#fff",
//           px: contextOpen ? 1 : 0,
//           py: 2,
//           transition: "width 0.3s ease",
//           overflowY: "auto",
//           position: "relative",
//         }}
//       >
//         {/* Toggle Button */}
//         <IconButton
//           onClick={() => setContextOpen(!contextOpen)}
//           size="small"
//           sx={{
//             position: "absolute",
//             top: 8,
//             right: contextOpen ? 8 : "50%",
//             transform: contextOpen ? "none" : "translateX(50%)",
//             color: "#fff",
//             bgcolor: "rgba(255,255,255,0.1)",
//             "&:hover": { bgcolor: "rgba(255,255,255,0.2)" },
//           }}
//         >
//           {contextOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//         </IconButton>

//         {contextOpen && (
//           <>
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 px: 1,
//                 mb: 1,
//               }}
//             >
//               <Typography variant="subtitle1" fontWeight="bold">
//                 {activeModule}
//               </Typography>
//               <IconButton size="small" sx={{ color: "#fff" }}>
//                 <AddIcon fontSize="small" />
//               </IconButton>
//             </Box>

//             {/* Search */}
//             <Box sx={{ px: 1, py: 1 }}>
//               <input
//                 type="text"
//                 placeholder={`Search ${activeModule}`}
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "none",
//                   outline: "none",
//                   backgroundColor: "#2a2b3b",
//                   color: "#fff",
//                 }}
//               />
//             </Box>

//             {/* Context Menu List */}
//             <List dense>
//               {(contextMenus[activeModule] || []).map((item, index) => (
//                 <ListItemButton
//                   key={index}
//                   sx={{
//                     color: "#fff",
//                     fontSize: "0.85rem",
//                     borderRadius: "6px",
//                     "&:hover": {
//                       backgroundColor: "#2e303d",
//                     },
//                   }}
//                 >
//                   <ListItemText primary={item} />
//                 </ListItemButton>
//               ))}
//             </List>
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// }


//color changes
// import React, { useState } from "react";
// import {
//   Box,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemText,
//   Tooltip,
//   Typography,
//   Divider,
// } from "@mui/material";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import AddIcon from "@mui/icons-material/Add";

// export default function MainSideNavBar() {
//   const [activeModule, setActiveModule] = useState("Reports");

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Sales", icon: <MonetizationOnIcon /> },
//     { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     { id: "Purchase", icon: <ShoppingBagIcon /> },
//   ];

//   const contextMenus = {
//     Reports: [
//       "Folders",
//       "All Reports",
//       "My Reports",
//       "Favorites",
//       "Recently Viewed",
//       "Scheduled Reports",
//       "Recently Deleted",
//       "---",
//       "Account and Contact Reports",
//       "Deal Reports",
//       "Lead Reports",
//       "Campaign Reports",
//       "Case and Solution Reports",
//       "Product Reports",
//       "Vendor Reports",
//       "Quote Reports",
//       "Sales Order Reports",
//       "Purchase Order Reports",
//       "Invoice Reports",
//       "Sales Metrics Reports",
//       "Email Reports",
//       "Meeting Reports",
//     ],
//     Sales: ["Leads", "Contacts", "Accounts", "Deals", "Tasks", "Quotes", "Sales Orders"],
//   };

//   return (
//     <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#0e1628" }}>
//       {/* Left Icon Bar */}
//       <Box
//         sx={{
//           width: 60,
//           backgroundColor: "#0e1628",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           py: 1,
//           borderRight: "1px solid #1e2b40",
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => setActiveModule(mod.id)}
//               sx={{
//                 color: activeModule === mod.id ? "#00bcd4" : "#aaa",
//                 my: 1,
//               }}
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}
//       </Box>

//       {/* Right Context Menu */}
//       <Box
//         sx={{
//           width: 260,
//           backgroundColor: "#162c47",
//           color: "#fff",
//           display: "flex",
//           flexDirection: "column",
//           py: 2,
//           px: 1.5,
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             mb: 2,
//           }}
//         >
//           <Typography variant="subtitle1" fontWeight="bold" color="#fff">
//             {activeModule}
//           </Typography>
//           <IconButton size="small" sx={{ color: "#9e9e9e" }}>
//             <AddIcon fontSize="small" />
//           </IconButton>
//         </Box>

//         {/* Search */}
//         <Box
//           sx={{
//             backgroundColor: "#203b5e",
//             borderRadius: 1,
//             px: 1.2,
//             py: 0.8,
//             mb: 2,
//           }}
//         >
//           <input
//             type="text"
//             placeholder="Search Folder"
//             style={{
//               width: "100%",
//               background: "transparent",
//               border: "none",
//               color: "#fff",
//               outline: "none",
//               fontSize: "0.875rem",
//             }}
//           />
//         </Box>

//         {/* Context Menu List */}
//         <Box sx={{ overflowY: "auto", flex: 1 }}>
//           <List dense disablePadding>
//             {(contextMenus[activeModule] || []).map((item, index) =>
//               item === "---" ? (
//                 <Divider
//                   key={`divider-${index}`}
//                   sx={{ backgroundColor: "#294769", my: 1 }}
//                 />
//               ) : (
//                 <ListItemButton
//                   key={index}
//                   sx={{
//                     px: 1.5,
//                     py: 0.7,
//                     color: item === "All Reports" ? "#fff" : "#b0bec5",
//                     fontWeight: item === "All Reports" ? 600 : 400,
//                     fontSize: "0.85rem",
//                     borderRadius: "6px",
//                     "&:hover": {
//                       backgroundColor: "#1e3a5d",
//                     },
//                     backgroundColor: item === "All Reports" ? "#245caa" : "transparent",
//                   }}
//                 >
//                   <ListItemText
//                     primary={item}
//                     primaryTypographyProps={{
//                       noWrap: true,
//                     }}
//                   />
//                 </ListItemButton>
//               )
//             )}
//           </List>
//         </Box>
//       </Box>
//     </Box>
//   );
// }



// import React, { useState } from "react";
// import {
//   Box,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Tooltip,
//   Typography,
//   Divider,
// } from "@mui/material";

// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import AddIcon from "@mui/icons-material/Add";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import FolderIcon from "@mui/icons-material/Folder";

// export default function MainSideNavBar() {
//   const [activeModule, setActiveModule] = useState("Reports");
//   const [contextOpen, setContextOpen] = useState(true);

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Sales", icon: <MonetizationOnIcon /> },
//     { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     { id: "Purchase", icon: <ShoppingBagIcon /> },
//   ];

//   const contextMenus = {
//     Reports: [
//       "All Reports",
//       "My Reports",
//       "Favorites",
//       "Recently Viewed",
//       "Scheduled Reports",
//       "Recently Deleted",
//       "Account and Contact Reports",
//       "Deal Reports",
//       "Lead Reports",
//       "Campaign Reports",
//       "Case and Solution Reports",
//       "Product Reports",
//       "Vendor Reports",
//       "Quote Reports",
//       "Sales Order Reports",
//       "Purchase Order Reports",
//       "Invoice Reports",
//       "Sales Metrics Reports",
//       "Email Reports",
//       "Meeting Reports",
//     ],
//     Sales: [
//       "Leads",
//       "Contacts",
//       "Accounts",
//       "Deals",
//       "Tasks",
//       "Meetings",
//       "Calls",
//       "Products",
//       "Quotes",
//       "Sales Orders",
//       "Purchase Orders",
//       "Invoices",
//       "SalesInbox",
//       "Campaigns",
//       "Vendors",
//       "Price Books",
//       "Cases",
//       "Solutions",
//       "Documents",
//       "Forecasts",
//       "Visits",
//       "Social",
//       "Services",
//       "Projects",
//     ],
//     Home: [],
//     Production: [],
//     Purchase: [],
//   };

//   return (
//     <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#0c0f1a" }}>
//       {/* Left Sidebar */}
//       <Box
//         sx={{
//           width: 60,
//           backgroundColor: "#0e1120",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           pt: 10,
//           color: "#fff",
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => setActiveModule(mod.id)}
//               sx={{
//                 color: activeModule === mod.id ? "#00bcd4" : "#fff",
//                 my: 1,
//               }}
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}

//         <Box sx={{ flexGrow: 1 }} />
//         <IconButton sx={{ mb: 1, color: "#fff" }}>
//           <AddIcon fontSize="small" />
//         </IconButton>
//       </Box>

//       {/* Right Context Panel */}
//       <Box
//         sx={{
//           width: contextOpen ? 260 : 0,
//           backgroundColor: "#1b1f33",
//           color: "#fff",
//           transition: "width 0.3s ease",
//           overflowX: "hidden",
//           position: "relative",
//         }}
//       >
//         {/* Collapse/Expand Button */}
//         <IconButton
//           onClick={() => setContextOpen(!contextOpen)}
//           size="small"
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: -16,
//             zIndex: 10,
//             color: "#fff",
//             bgcolor: "#2b2f42",
//             "&:hover": { bgcolor: "#3a3f56" },
//             borderRadius: "50%",
//           }}
//         >
//           {contextOpen ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
//         </IconButton>

//         {contextOpen && (
//           <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
//             <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//               <Typography fontWeight="bold" fontSize="1rem">
//                 {activeModule}
//               </Typography>
//               <IconButton size="small" sx={{ color: "#fff" }}>
//                 <AddIcon fontSize="small" />
//               </IconButton>
//             </Box>

//             {/* Search */}
//             <Box sx={{ px: 2, pb: 1 }}>
//               <input
//                 type="text"
//                 placeholder="Search"
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "none",
//                   outline: "none",
//                   backgroundColor: "#2a2d3e",
//                   color: "#fff",
//                 }}
//               />
//             </Box>

//             <Divider sx={{ backgroundColor: "#444", mx: 2, my: 1 }} />

//             {/* Context Menu List */}
//             <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
//               <List dense>
//                 {(contextMenus[activeModule] || []).map((item, index) => (
//                   <ListItemButton
//                     key={index}
//                     sx={{
//                       color: "#fff",
//                       borderRadius: "6px",
//                       "&:hover": {
//                         backgroundColor: "#2a2d3e",
//                       },
//                       mx: 1,
//                       my: 0.5,
//                     }}
//                   >
//                     <ListItemIcon sx={{ color: "#9aa2c3", minWidth: 30 }}>
//                       <FolderIcon fontSize="small" />
//                     </ListItemIcon>
//                     <ListItemText primaryTypographyProps={{ fontSize: "0.85rem" }} primary={item} />
//                   </ListItemButton>
//                 ))}
//               </List>
//             </Box>

//             {/* Bottom Footer Section */}
//             <Box sx={{ px: 2, py: 1 }}>
//               <Box
//                 sx={{
//                   backgroundColor: "#2a2d3e",
//                   borderRadius: "8px",
//                   padding: "8px 10px",
//                   fontSize: "0.8rem",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Box
//                     sx={{
//                       backgroundColor: "#ffd600",
//                       borderRadius: "4px",
//                       color: "#000",
//                       fontWeight: "bold",
//                       padding: "2px 6px",
//                       fontSize: "0.75rem",
//                       mr: 1,
//                     }}
//                   >
//                     CT
//                   </Box>
//                   CRM Teamspace
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// }


// import React, { useState } from "react";
// import {
//   Box,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   Tooltip,
//   Typography,
// } from "@mui/material";

// import AddIcon from "@mui/icons-material/Add";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import FolderIcon from "@mui/icons-material/Folder";

// export default function MainSideNavBar() {
//   const [activeModule, setActiveModule] = useState("Reports");
//   const [contextOpen, setContextOpen] = useState(false);

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Sales", icon: <MonetizationOnIcon /> },
//     { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     { id: "Purchase", icon: <ShoppingBagIcon /> },
//   ];

//   const contextMenus = {
//     Reports: [
//       "All Reports", "My Reports", "Favorites", "Recently Viewed", "Scheduled Reports",
//       "Recently Deleted", "Account and Contact Reports", "Deal Reports", "Lead Reports",
//       "Campaign Reports", "Case and Solution Reports", "Product Reports", "Vendor Reports",
//       "Quote Reports", "Sales Order Reports", "Purchase Order Reports", "Invoice Reports",
//       "Sales Metrics Reports", "Email Reports", "Meeting Reports",
//     ],
//     Sales: [
//       "Leads", "Contacts", "Accounts", "Deals", "Tasks", "Meetings", "Calls", "Products",
//       "Quotes", "Sales Orders", "Purchase Orders", "Invoices", "SalesInbox", "Campaigns",
//       "Vendors", "Price Books", "Cases", "Solutions", "Documents", "Forecasts",
//       "Visits", "Social", "Services", "Projects",
//     ],
//     Home: [],
//     Production: [],
//     Purchase: [],
//   };

//   return (
//     <Box sx={{ display: "flex", height: "100vh", backgroundColor: "#0c0f1a" }}>
//       {/* Left Sidebar */}
//       <Box
//         sx={{
//           width: 60,
//           backgroundColor: "#0e1120",
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           pt: 10,
//           pb: 3,
//           color: "#fff",
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => setActiveModule(mod.id)}
//               sx={{
//                 color: activeModule === mod.id ? "#00bcd4" : "#fff",
//                 my: 1,
//               }}
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}
//         <Box sx={{ flexGrow: 1 }} />
//         <IconButton sx={{ mb: 1, color: "#fff" }}>
//           <AddIcon fontSize="small" />
//         </IconButton>
//       </Box>

//       {/* Right Context Panel */}
//       <Box
//         sx={{
//           width: contextOpen ? 260 : 60,
//           backgroundColor: "#1b1f33",
//           color: "#fff",
//           transition: "width 0.3s ease",
//           overflow: "hidden",
//           position: "relative",
//         }}
//       >
//         {/* Always visible toggle button */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 10,
//             right: -12,
//             zIndex: 10,
//           }}
//         >
//           <IconButton
//             onClick={() => setContextOpen((prev) => !prev)}
//             size="small"
//             sx={{
//               color: "#fff",
//               bgcolor: "#2b2f42",
//               "&:hover": { bgcolor: "#3a3f56" },
//               borderRadius: "50%",
//               boxShadow: 2,
//             }}
//           >
//             {contextOpen ? (
//               <ChevronLeftIcon fontSize="small" />
//             ) : (
//               <ChevronRightIcon fontSize="small" />
//             )}
//           </IconButton>
//         </Box>

//         {/* Conditional content */}
//         {contextOpen ? (
//           <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
//             {/* Header */}
//             <Box sx={{ p: 2, display: "flex", justifyContent: "space-between" }}>
//               <Typography fontWeight="bold" fontSize="1rem">
//                 {activeModule}
//               </Typography>
//               <IconButton size="small" sx={{ color: "#fff" }}>
//                 <AddIcon fontSize="small" />
//               </IconButton>
//             </Box>

//             {/* Search */}
//             <Box sx={{ px: 2, pb: 1 }}>
//               <input
//                 type="text"
//                 placeholder="Search"
//                 style={{
//                   width: "100%",
//                   padding: "6px 10px",
//                   borderRadius: "6px",
//                   border: "none",
//                   outline: "none",
//                   backgroundColor: "#2a2d3e",
//                   color: "#fff",
//                 }}
//               />
//             </Box>

//             <Divider sx={{ backgroundColor: "#444", mx: 2, my: 1 }} />

//             {/* Context Menu List */}
//             <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
//               <List dense>
//                 {(contextMenus[activeModule] || []).map((item, index) => (
//                   <ListItemButton
//                     key={index}
//                     sx={{
//                       color: "#fff",
//                       borderRadius: "6px",
//                       "&:hover": {
//                         backgroundColor: "#2a2d3e",
//                       },
//                       mx: 1,
//                       my: 0.5,
//                     }}
//                   >
//                     <ListItemIcon sx={{ color: "#9aa2c3", minWidth: 30 }}>
//                       <FolderIcon fontSize="small" />
//                     </ListItemIcon>
//                     <ListItemText
//                       primaryTypographyProps={{ fontSize: "0.85rem" }}
//                       primary={item}
//                     />
//                   </ListItemButton>
//                 ))}
//               </List>
//             </Box>

//             {/* Footer */}
//             <Box sx={{ px: 2, py: 1 }}>
//               <Box
//                 sx={{
//                   backgroundColor: "#2a2d3e",
//                   borderRadius: "8px",
//                   padding: "8px 10px",
//                   fontSize: "0.8rem",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Box
//                     sx={{
//                       backgroundColor: "#ffd600",
//                       borderRadius: "4px",
//                       color: "#000",
//                       fontWeight: "bold",
//                       padding: "2px 6px",
//                       fontSize: "0.75rem",
//                       mr: 1,
//                     }}
//                   >
//                     CT
//                   </Box>
//                   CRM Teamspace
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         ) : (
//           <Box
//             sx={{
//               height: "100%",
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               pt: 8,
//             }}
//           >
//             <Tooltip title="Expand" placement="right">
//               <IconButton onClick={() => setContextOpen(true)} sx={{ color: "#fff", mt: 1 }}>
//                 <FolderIcon />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// }

// // set 4
import React, { useState } from "react";
import {
  Box,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Typography,
  TextField,
  alpha,
  useTheme
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BarChartIcon from "@mui/icons-material/BarChart";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';

// new icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import StoreIcon from '@mui/icons-material/Store';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InventoryIcon from '@mui/icons-material/Inventory';

import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PersonIcon from '@mui/icons-material/Person';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import DeleteIcon from '@mui/icons-material/Delete';
import ReportIcon from '@mui/icons-material/Assessment';
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LogoutIcon from "@mui/icons-material/Logout";
import PieChartIcon from '@mui/icons-material/PieChart';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { useNavigate } from "react-router-dom";


import { useEffect } from "react";
import useUserPermissions from "../../components/user-permission/UserPermission";
import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
import { AddShoppingCart, Engineering } from "@mui/icons-material";
import { tokens } from "../../theme/theme";



export default function MainSideNavBar({ open, collapsed, setCollapsed, drawerWidth, onLogout }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [activeModule, setActiveModule] = useState("Modules");
  const [contextOpen, setContextOpen] = useState(true);
  const [openMenus, setOpenMenus] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();


  const userPermissions = useUserPermissions();
  const [userID, setUserID] = useState(null);
  const [companyid, setCompanyid] = useState('');

  useEffect(() => {
    const retrievedUserID = localStorage.getItem('userID');
    if (retrievedUserID) {
      setUserID(retrievedUserID);
      setCompanyid(localStorage.getItem('companyid'));
    }
  }, []); // Empty dependency array to run only once on mount

  const primaryModules = [
    { id: "Home", icon: <HomeOutlinedIcon /> },
    // { id: "PapyAI", icon: <AutoAwesomeIcon /> },
    { id: "Modules", icon: <FolderOpenOutlinedIcon /> },
    // { id: "Reports", icon: <BarChartIcon /> },
    // { id: "Dashboards", icon: <PieChartIcon /> },
    // { id: "Order", icon: <MonetizationOnIcon /> },
    // { id: "Sales", icon: <MonetizationOnIcon /> },
    // { id: "Production", icon: <PrecisionManufacturingIcon /> },
    // { id: "Purchase", icon: <ShoppingBagIcon /> },
  ];

  const contextMenus = {
    Modules: [
      { title: "Dashboard", icon: <DashboardIcon />, path: "/" },
      // { title: "PapyAI", icon: <AutoAwesomeIcon />, path: "/ai" },
       { title: "Master Data", icon: <SettingsIcon />, path: "/master-menu", parentModuleName: 'Master' },
       { title: "Transactions", icon: <AssignmentIcon />, path: "/transaction-menu", parentModuleName: 'Transaction' },
      // { title: "Order Management", icon: <AddShoppingCart />, path: "/order-management", parentModuleName: 'Order' },
      // { title: "Sales", icon: <MonetizationOnIcon />, path: "/sales-management", parentModuleName: 'Sales' },
      // { title: "Inventory", icon: <ShoppingBagIcon />, path: "/store-management" },
      //{ title: "Procurement", icon: <ShoppingBagIcon />, path: "/purchase-management" },

      
       { title: "Manufacturing", icon: <PrecisionManufacturingIcon />, path: "/production-management", parentModuleName: 'Production' },
      // { title: "Warehouse Old", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
      // { title: "Warehouse", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
      // { title: "Warehouse Management", icon: <BusinessIcon />, path: "/warehouse-new-management", parentModuleName: 'Warehouse' },
      // { title: "Bill of Materials (BOM)", icon: <Engineering />, path: "/bill-of-material" },
     
      // { title: "Warehouse Old", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
      //{ title: "Warehouse", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
       { title: "Warehouse Management", icon: <BusinessIcon />, path: "/warehouse-new-management", parentModuleName: 'Warehouse' },
      //{ title: "Bill of Materials (BOM)", icon: <Engineering />, path: "/bill-of-material" },


      // { title: "Cost Management", icon: <MonetizationOnIcon />, path: "/costing-management" },
      // { title: "Human Resources(HR)", icon: <Engineering />, path: "/human-resource" },
      //{ title: "Organization Management", icon: <BusinessIcon />, path: "/company-management" },

    ],
    Reports: [
      { title: "All Reports", path: "/reports/all" },
      { title: "My Reports", path: "/reports/mine" },
      { title: "Favorites", path: "/reports/favorites" },
      { title: "Recently Viewed", path: "/reports/recently-viewed" },
      { title: "Product Reports", path: "/reports/product" },
      { title: "Vendor Reports", path: "/reports/vendor" },
      { title: "Quote Reports", path: "/reports/quote" },
      { title: "Sales Order Reports", path: "/reports/sales-order" },
      { title: "Purchase Order Reports", path: "/reports/purchase-order" },
      { title: "Production Order Reports", path: "/production-management-report" },
      { title: "Invoice Reports", path: "/reports/invoice" },
      { title: "Warehouse Reports", path: "/reports/purchase-order" },
      { title: "Costing Reports", path: "/reports/purchase-order" },
    ],
    Dashboards: [
      { title: "Organization OverView", icon: <DashboardIcon />, path: "/organization-overview" },
      { title: "Purchase Analystics", icon: <ShoppingBagIcon />, path: "/" },
      { title: "Production Analystics", icon: <PrecisionManufacturingIcon />, path: "/production-overview" },
      { title: "Warehouse Analystics", icon: <WarehouseIcon />, path: "/warehouse-overview" },
    ],
    Sales: [
      { title: "Leads", path: "/sales/leads" },
      { title: "Contacts", path: "/sales/contacts" },
      { title: "Accounts", path: "/sales/accounts" },
      { title: "Deals", path: "/sales/deals" },
      { title: "Tasks", path: "/sales/tasks" },
      { title: "Meetings", path: "/sales/meetings" },
      { title: "Calls", path: "/sales/calls" },
      { title: "Products", path: "/sales/products" },
      { title: "Quotes", path: "/sales/quotes" },
      { title: "Sales Orders", path: "/sales/sales-orders" },
      { title: "Purchase Orders", path: "/sales/purchase-orders" },
      { title: "Invoices", path: "/sales/invoices" },
      { title: "SalesInbox", path: "/sales/inbox" },
      { title: "Campaigns", path: "/sales/campaigns" },
      { title: "Vendors", path: "/sales/vendors" },
      { title: "Price Books", path: "/sales/price-books" },
      { title: "Cases", path: "/sales/cases" },
      { title: "Solutions", path: "/sales/solutions" },
      { title: "Documents", path: "/sales/documents" },
      { title: "Forecasts", path: "/sales/forecasts" },
      { title: "Visits", path: "/sales/visits" },
      { title: "Social", path: "/sales/social" },
      { title: "Services", path: "/sales/services" },
      { title: "Projects", path: "/sales/projects" },
    ],
    Home: [],
    Production: [],
    Purchase: [],
  };

  if (hasPermission(userPermissions, "User Management", "Enabled")) {
    contextMenus.Modules.push({
      title: "User Management",
      icon: <ManageAccountsIcon />,
      path: `/UserList/${companyid}`,
    });
  }

  
   if (localStorage.getItem('is_system_admin') === 'true') {
    contextMenus.Modules.push({
      title: "Organization Management",
      icon: <BusinessIcon />,
      path: `/company-management`,
    });
  }

  const contextIcons = {
    "Home": <DashboardIcon fontSize="small" />,
    "Master": <SettingsIcon fontSize="small" />,
    "Transaction": <AssignmentIcon fontSize="small" />,
    "Sales": <StoreIcon fontSize="small" />,
    "Store": <InventoryIcon fontSize="small" />,
    "Purchase Order": <ShoppingBagIcon fontSize="small" />,
    "Production": <PrecisionManufacturingIcon fontSize="small" />,
    "Warehouse": <BusinessIcon fontSize="small" />,
    "Bill of Material": <AccountTreeIcon fontSize="small" />,
    "Costing": <MonetizationOnIcon fontSize="small" />,
    "Human Resource": <PersonIcon fontSize="small" />,
    "Company Management": <BusinessIcon fontSize="small" />,
    "User Management": <ManageAccountsIcon fontSize="small" />,
    "Cat": <ManageAccountsIcon fontSize="small" />,

    "All Reports": <ReportIcon fontSize="small" />,
    "My Reports": <ReportIcon fontSize="small" />,
    "Favorites": <StarBorderOutlinedIcon fontSize="small" />,
    "Recently Viewed": <VisibilityOutlinedIcon fontSize="small" />,
    "Scheduled Reports": <AccessTimeOutlinedIcon fontSize="small" />,
    "Recently Deleted": <DeleteIcon fontSize="small" />,
    "Account and Contact Reports": <PeopleIcon fontSize="small" />,
    // Add similar mappings for the rest...
  };

  const toggleMenu = (title) => {
    setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
  };

  const filteredItems = (contextMenus[activeModule] || []).filter((item) =>
    item.title.toLowerCase().includes(searchTerm.toLowerCase())
  );



  return (
    <Box sx={{
      display: 'flex',
      height: '100vh',
      backgroundColor: alpha(colors.primary[400], 0.1),
      backdropFilter: 'blur(20px)',
      borderRight: `1px solid ${alpha(colors.primary[400], 0.3)}`
    }}>
      {/* Left Sidebar */}
      <Box
        sx={{
          width: 40,
          backgroundColor: "#0e1120",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: 7,
          pb: 3,
          color: "#fff",
        }}
      >
        {primaryModules.map((mod) => (
          <Tooltip title={mod.id} placement="right" key={mod.id}>
            <IconButton
              onClick={() => {
                setActiveModule(mod.id);
                setContextOpen(true); // Expand when any module is clicked
              }}
              sx={{
                color: activeModule === mod.id ? "#00bcd4" : "#fff",
                my: 1,
              }}
            >
              {mod.icon}
            </IconButton>
          </Tooltip>
        ))}
        <Box sx={{ flexGrow: 1 }} />
        <IconButton onClick={onLogout} sx={{ mb: 1, color: "#fff" }}>
          <LogoutIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Right Context Panel */}
      <Box
        onMouseEnter={() => { setHovered(true); setContextOpen(true); }}
        onMouseLeave={() => setHovered(false)}

        sx={{
          width: hovered || contextOpen ? 260 : 8,
          backgroundColor: "#1b1f33", backgroundColor: "#162c47",
          color: "#fff",
          transition: "width 0.3s ease",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}

      >

        {/* Toggle Button */}
        {contextOpen ? (
          <>
            {/* Header */}
            <Box sx={{ p: 2, pt: 8, display: "flex", justifyContent: "space-between" }}>
              <Typography fontWeight="bold" fontSize="1rem">
                {activeModule}
              </Typography>
              <IconButton size="small" sx={{ color: "#fff" }}>
                <AddIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Search */}
            <Box sx={{ px: 2, pb: 1 }}>

              <TextField
                size="small"
                placeholder="Search..."
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  m: 0.5,
                  input: { color: '#fff' },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#555' },
                    '&:hover fieldset': { borderColor: '#888' },
                    '&.Mui-focused fieldset': { borderColor: '#aaa' },
                  },

                }}
                InputProps={{
                  sx: { height: 36, backgroundColor: '#1e1f2b', color: '#fff' },
                }}
              />
            </Box>

            <Divider sx={{ backgroundColor: "#444", mx: 2, my: 1 }} />

            {/* Context Menu List */}

            <Box sx={{ flexGrow: 1, overflowY: "auto" }}>

              {filteredItems.map((item, index) => (
                <ListItemButton
                  key={index}

                  onClick={() => {
                    setSelectedItem(item.title); // or item.path or item.id, depending on uniqueness
                    if (item.submenu) {
                      toggleMenu(item.title);
                    } else {
                      navigate(item.path);
                    }
                  }}

                  sx={{
                    size: 'small',
                    color: "#fff",
                    padding: '1px',
                    borderRadius: "6px",
                    backgroundColor: selectedItem === item.title ? "#01579b" : "transparent",
                    "&:hover": {
                      backgroundColor: "#01579b",
                    },
                    mx: 1.5,
                    my: 0.5,
                  }}
                >
                  <ListItemIcon sx={{ color: "#9aa2c3", minWidth: 30, size: 'small' }}>
                    {item.icon || <FolderIcon fontSize="small" />}
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: "0.85rem", fontWeight: "bold" }}
                    primary={item.title}
                  />
                </ListItemButton>
              ))}
            </Box>


            {/* Footer */}
            {/* <Box sx={{ px: 2, py: 1 }}>
              <Box
                sx={{
                  backgroundColor: "#2a2d3e",
                  borderRadius: "8px",
                  padding: "8px 10px",
                  fontSize: "0.8rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      backgroundColor: "#ffd600",
                      borderRadius: "4px",
                      color: "#000",
                      fontWeight: "bold",
                      padding: "2px 6px",
                      fontSize: "0.75rem",
                      mr: 1,
                    }}
                  >
                    Optrim
                  </Box>
                  Deckle Matching
                </Box>
              </Box>
            </Box> */}
          </>
        ) : (
          <Box sx={{ flexGrow: 1 }} />
        )}

        {/* Always Visible Toggle Button at Bottom */}
        {hovered || contextOpen ? (
          <Box sx={{ p: 1, display: "flex", justifyContent: "center" }}>
            <IconButton
              onClick={() => setContextOpen((prev) => !prev)}
              sx={{
                color: "#fff",
                bgcolor: "#2b2f42",
                "&:hover": { bgcolor: "#3a3f56" },
                borderRadius: "50%",
                boxShadow: 2,
              }}
            >
              {hovered || contextOpen ? (
                <ChevronLeftIcon fontSize="small" sx={{ fontSize: '10px' }} />
              ) : (
                // null
                <ChevronRightIcon fontSize="small" sx={{ fontSize: '10px' }} />
              )}
            </IconButton>
          </Box>
        ) : (
          // null
          <ChevronRightIcon fontSize="small" sx={{ fontSize: '10px' }} />
        )}

      </Box>
    </Box>
  );
}


// import React, { useState } from "react";
// import {
//   Box,
//   IconButton,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   Tooltip,
//   Typography,
//   TextField,
//   alpha,
//   useTheme
// } from "@mui/material";

// import AddIcon from "@mui/icons-material/Add";
// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import BarChartIcon from "@mui/icons-material/BarChart";
// import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
// import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
// import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import FolderIcon from "@mui/icons-material/Folder";
// import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';

// // new icons
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import SettingsIcon from '@mui/icons-material/Settings';
// import PeopleIcon from '@mui/icons-material/People';
// import BusinessIcon from '@mui/icons-material/Business';
// import StoreIcon from '@mui/icons-material/Store';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import InventoryIcon from '@mui/icons-material/Inventory';

// import AccountTreeIcon from '@mui/icons-material/AccountTree';
// import PersonIcon from '@mui/icons-material/Person';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// import DeleteIcon from '@mui/icons-material/Delete';
// import ReportIcon from '@mui/icons-material/Assessment';
// import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
// import LogoutIcon from "@mui/icons-material/Logout";
// import PieChartIcon from '@mui/icons-material/PieChart';
// import WarehouseIcon from '@mui/icons-material/Warehouse';
// import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
// import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// import { useNavigate } from "react-router-dom";


// import { useEffect } from "react";
// import useUserPermissions from "../../components/user-permission/UserPermission";
// import { hasPermission } from "../../components/user-permission/AuthorizationParameter";
// import { AddShoppingCart, Engineering } from "@mui/icons-material";
// import { tokens } from "../../theme/theme";



// export default function MainSideNavBar({ open, collapsed, setCollapsed, drawerWidth, onLogout }) {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [activeModule, setActiveModule] = useState("Modules");
//   const [contextOpen, setContextOpen] = useState(true);
//   const [openMenus, setOpenMenus] = useState({});
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [hovered, setHovered] = useState(false);
//   const navigate = useNavigate();


//   const userPermissions = useUserPermissions();
//   const [userID, setUserID] = useState(null);
//   const [companyid, setCompanyid] = useState('');

//   useEffect(() => {
//     const retrievedUserID = localStorage.getItem('userID');
//     if (retrievedUserID) {
//       setUserID(retrievedUserID);
//       setCompanyid(localStorage.getItem('companyid'));
//     }
//   }, []); // Empty dependency array to run only once on mount

//   const primaryModules = [
//     { id: "Home", icon: <HomeOutlinedIcon /> },
//     { id: "PapyAI", icon: <AutoAwesomeIcon /> },
//     { id: "Modules", icon: <FolderOpenOutlinedIcon /> },
//     { id: "Reports", icon: <BarChartIcon /> },
//     { id: "Dashboards", icon: <PieChartIcon /> },
//     // { id: "Order", icon: <MonetizationOnIcon /> },
//     // { id: "Sales", icon: <MonetizationOnIcon /> },
//     // { id: "Production", icon: <PrecisionManufacturingIcon /> },
//     // { id: "Purchase", icon: <ShoppingBagIcon /> },
//   ];

//   const contextMenus = {
//     Modules: [
//       { title: "Dashboard", icon: <DashboardIcon />, path: "/" },
//       { title: "PapyAI", icon: <AutoAwesomeIcon />, path: "/ai" },
//       { title: "Master Data", icon: <SettingsIcon />, path: "/master-menu", parentModuleName: 'Master' },
//       { title: "Transactions", icon: <AssignmentIcon />, path: "/transaction-menu", parentModuleName: 'Transaction' },
//       { title: "Order Management", icon: <AddShoppingCart />, path: "/order-management", parentModuleName: 'Order' },
//       { title: "Sales", icon: <MonetizationOnIcon />, path: "/sales-management", parentModuleName: 'Sales' },
//       { title: "Inventory", icon: <ShoppingBagIcon />, path: "/store-management" },
//       { title: "Procurement", icon: <ShoppingBagIcon />, path: "/purchase-management" },
//       { title: "Manufacturing", icon: <PrecisionManufacturingIcon />, path: "/production-management", parentModuleName: 'Production' },
//       // { title: "Warehouse Old", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
//       //{ title: "Warehouse", icon: <BusinessIcon />, path: "/warehouse-management", parentModuleName: 'Warehouse' },
//       { title: "Warehouse Management", icon: <BusinessIcon />, path: "/warehouse-new-management", parentModuleName: 'Warehouse' },
//       { title: "Bill of Materials (BOM)", icon: <Engineering />, path: "/bill-of-material" },

//       { title: "Cost Management", icon: <MonetizationOnIcon />, path: "/costing-management" },
//       { title: "Human Resources(HR)", icon: <Engineering />, path: "/human-resource" },
//       { title: "Organization Management", icon: <BusinessIcon />, path: "/company-management" },

//     ],
//     Reports: [
//       { title: "All Reports", path: "/reports/all" },
//       { title: "My Reports", path: "/reports/mine" },
//       { title: "Favorites", path: "/reports/favorites" },
//       { title: "Recently Viewed", path: "/reports/recently-viewed" },
//       { title: "Product Reports", path: "/reports/product" },
//       { title: "Vendor Reports", path: "/reports/vendor" },
//       { title: "Quote Reports", path: "/reports/quote" },
//       { title: "Sales Order Reports", path: "/reports/sales-order" },
//       { title: "Purchase Order Reports", path: "/reports/purchase-order" },
//       { title: "Production Order Reports", path: "/production-management-report" },
//       { title: "Invoice Reports", path: "/reports/invoice" },
//       { title: "Warehouse Reports", path: "/reports/purchase-order" },
//       { title: "Costing Reports", path: "/reports/purchase-order" },
//     ],
//     Dashboards: [
//       { title: "Organization OverView", icon: <DashboardIcon />, path: "/organization-overview" },
//       { title: "Purchase Analystics", icon: <ShoppingBagIcon />, path: "/" },
//       { title: "Production Analystics", icon: <PrecisionManufacturingIcon />, path: "/production-overview" },
//       { title: "Warehouse Analystics", icon: <WarehouseIcon />, path: "/warehouse-overview" },
//     ],
//     Sales: [
//       { title: "Leads", path: "/sales/leads" },
//       { title: "Contacts", path: "/sales/contacts" },
//       { title: "Accounts", path: "/sales/accounts" },
//       { title: "Deals", path: "/sales/deals" },
//       { title: "Tasks", path: "/sales/tasks" },
//       { title: "Meetings", path: "/sales/meetings" },
//       { title: "Calls", path: "/sales/calls" },
//       { title: "Products", path: "/sales/products" },
//       { title: "Quotes", path: "/sales/quotes" },
//       { title: "Sales Orders", path: "/sales/sales-orders" },
//       { title: "Purchase Orders", path: "/sales/purchase-orders" },
//       { title: "Invoices", path: "/sales/invoices" },
//       { title: "SalesInbox", path: "/sales/inbox" },
//       { title: "Campaigns", path: "/sales/campaigns" },
//       { title: "Vendors", path: "/sales/vendors" },
//       { title: "Price Books", path: "/sales/price-books" },
//       { title: "Cases", path: "/sales/cases" },
//       { title: "Solutions", path: "/sales/solutions" },
//       { title: "Documents", path: "/sales/documents" },
//       { title: "Forecasts", path: "/sales/forecasts" },
//       { title: "Visits", path: "/sales/visits" },
//       { title: "Social", path: "/sales/social" },
//       { title: "Services", path: "/sales/services" },
//       { title: "Projects", path: "/sales/projects" },
//     ],
//     Home: [],
//     Production: [],
//     Purchase: [],
//   };

//   if (hasPermission(userPermissions, "User Management", "Enabled")) {
//     contextMenus.Modules.push({
//       title: "User Management",
//       icon: <ManageAccountsIcon />,
//       path: `/UserList/${companyid}`,
//     });
//   }


//   const contextIcons = {
//     "Home": <DashboardIcon fontSize="small" />,
//     "Master": <SettingsIcon fontSize="small" />,
//     "Transaction": <AssignmentIcon fontSize="small" />,
//     "Sales": <StoreIcon fontSize="small" />,
//     "Store": <InventoryIcon fontSize="small" />,
//     "Purchase Order": <ShoppingBagIcon fontSize="small" />,
//     "Production": <PrecisionManufacturingIcon fontSize="small" />,
//     "Warehouse": <BusinessIcon fontSize="small" />,
//     "Bill of Material": <AccountTreeIcon fontSize="small" />,
//     "Costing": <MonetizationOnIcon fontSize="small" />,
//     "Human Resource": <PersonIcon fontSize="small" />,
//     "Company Management": <BusinessIcon fontSize="small" />,
//     "User Management": <ManageAccountsIcon fontSize="small" />,
//     "Cat": <ManageAccountsIcon fontSize="small" />,

//     "All Reports": <ReportIcon fontSize="small" />,
//     "My Reports": <ReportIcon fontSize="small" />,
//     "Favorites": <StarBorderOutlinedIcon fontSize="small" />,
//     "Recently Viewed": <VisibilityOutlinedIcon fontSize="small" />,
//     "Scheduled Reports": <AccessTimeOutlinedIcon fontSize="small" />,
//     "Recently Deleted": <DeleteIcon fontSize="small" />,
//     "Account and Contact Reports": <PeopleIcon fontSize="small" />,
//     // Add similar mappings for the rest...
//   };

//   const toggleMenu = (title) => {
//     setOpenMenus((prev) => ({ ...prev, [title]: !prev[title] }));
//   };

//   const filteredItems = (contextMenus[activeModule] || []).filter((item) =>
//     item.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );



//   return (
//     <Box sx={{
//       display: 'flex',
//       height: '100vh',
//       backgroundColor: alpha(colors.primary[400], 0.1),
//       backdropFilter: 'blur(20px)',
//       borderRight: `1px solid ${alpha(colors.primary[400], 0.3)}`
//     }}>
//       {/* Left Sidebar */}
//       <Box
//         // sx={{
//         //   width: 40,
//         //   backgroundColor: "#0e1120",
//         //   display: "flex",
//         //   flexDirection: "column",
//         //   alignItems: "center",
//         //   pt: 7,
//         //   pb: 3,
//         //   color: "#fff",
//         // }}
//         sx={{
//           width: 50,
//           backgroundColor: alpha(colors.grey[900], 0.95),
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           pt: 7,
//           pb: 3,
//           transition: 'width 0.3s ease'
//         }}
//       >
//         {primaryModules.map((mod) => (
//           <Tooltip title={mod.id} placement="right" key={mod.id}>
//             <IconButton
//               onClick={() => {
//                 setActiveModule(mod.id);
//                 setContextOpen(true); // Expand when any module is clicked
//               }}
//               // sx={{
//               //   color: activeModule === mod.id ? "#00bcd4" : "#fff",
//               //   my: 1,
//               // }}

//               sx={{
//                 color: activeModule === mod.id ? colors.primary[400] : colors.grey[400],
//                 my: 1.5,
//                 transition: 'all 0.2s ease',
//                 '&:hover': {
//                   backgroundColor: alpha(colors.primary[400], 0.15),
//                   transform: 'scale(1.1)',
//                   color: colors.primary[400]
//                 }
//               }}
//             >
//               {mod.icon}
//             </IconButton>
//           </Tooltip>
//         ))}
//         <Box sx={{ flexGrow: 1 }} />
//         <IconButton onClick={onLogout} sx={{ mb: 1, color: colors.grey[400] }}>
//           <LogoutIcon fontSize="small" />
//         </IconButton>
//       </Box>

//       {/* Right Context Panel */}
//       <Box
//         onMouseEnter={() => { setHovered(true); setContextOpen(true); }}
//         onMouseLeave={() => setHovered(false)}

//         // sx={{
//         //   width: hovered || contextOpen ? 260 : 8,
//         //   backgroundColor: "#1b1f33", backgroundColor: "#162c47",
//         //   color: "#fff",
//         //   transition: "width 0.3s ease",
//         //   overflow: "hidden",
//         //   display: "flex",
//         //   flexDirection: "column",
//         // }}

//         sx={{
//           width: hovered || contextOpen ? 280 : 0,
//           backgroundColor: alpha(colors.grey[900], 0.98),
//           backdropFilter: 'blur(20px)',
//           color: colors.grey[100],
//           transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
//           overflow: 'hidden',
//           display: 'flex',
//           flexDirection: 'column',
//           borderLeft: `1px solid ${alpha(colors.primary[400], 0.2)}`
//         }}

//       >

//         {/* Toggle Button */}
//         {contextOpen ? (
//           <>
//             {/* Header */}
//             {/* <Box sx={{ p: 2, pt: 8, display: "flex", justifyContent: "space-between" }}>
//               <Typography fontWeight="bold" fontSize="1rem">
//                 {activeModule}
//               </Typography>
//               <IconButton size="small" sx={{ color: "#fff" }}>
//                 <AddIcon fontSize="small" />
//               </IconButton>
//             </Box> */}
//             <Box sx={{ p: 2.5, pt: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Typography variant="h6" fontWeight={700} color={colors.primary[400]}>
//                 {activeModule}
//               </Typography>
//               <IconButton size="small" onClick={() => setContextOpen(prev => !prev)} sx={{ color: colors.grey[400] }}>
//                 {contextOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//               </IconButton>
//             </Box>

//             {/* Search */}
//             {/* <Box sx={{ px: 2, pb: 1 }}>

//               <TextField
//                 size="small"
//                 placeholder="Search..."
//                 variant="outlined"
//                 fullWidth
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 sx={{
//                   m: 0.5,
//                   input: { color: '#fff' },
//                   '& .MuiOutlinedInput-root': {
//                     '& fieldset': { borderColor: '#555' },
//                     '&:hover fieldset': { borderColor: '#888' },
//                     '&.Mui-focused fieldset': { borderColor: '#aaa' },
//                   },

//                 }}
//                 InputProps={{
//                   sx: { height: 36, backgroundColor: '#1e1f2b', color: '#fff' },
//                 }}
//               />
//             </Box> */}

//             {/* <Divider sx={{ backgroundColor: "#444", mx: 2, my: 1 }} /> */}
//             <Box sx={{ px: 2.5, pb: 2 }}>
//               <TextField
//                 size="small"
//                 placeholder="Search modules..."
//                 variant="outlined"
//                 fullWidth
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: 2,
//                     height: 36,
//                     backgroundColor: alpha(colors.grey[800], 0.8),
//                     borderColor: alpha(colors.primary[400], 0.3),
//                     '&:hover': { borderColor: colors.primary[400] },
//                     '&.Mui-focused': {
//                       borderColor: colors.primary[400],
//                       backgroundColor: colors.grey[800]
//                     }
//                   },
//                   '& .MuiInputBase-input': { color: colors.grey[100], py: 0.75 }
//                 }}
//               />
//             </Box>

//             <Divider sx={{ backgroundColor: alpha(colors.primary[400], 0.3), mx: 2.5 }} />

//             {/* Context Menu List */}

//             {/* <Box sx={{ flexGrow: 1, overflowY: "auto" }}>

//               {filteredItems.map((item, index) => (
//                 <ListItemButton
//                   key={index}

//                   onClick={() => {
//                     setSelectedItem(item.title); // or item.path or item.id, depending on uniqueness
//                     if (item.submenu) {
//                       toggleMenu(item.title);
//                     } else {
//                       navigate(item.path);
//                     }
//                   }}

//                   sx={{
//                     size: 'small',
//                     color: "#fff",
//                     padding: '1px',
//                     borderRadius: "6px",
//                     backgroundColor: selectedItem === item.title ? "#01579b" : "transparent",
//                     "&:hover": {
//                       backgroundColor: "#01579b",
//                     },
//                     mx: 1.5,
//                     my: 0.5,
//                   }}
//                 >
//                   <ListItemIcon sx={{ color: "#9aa2c3", minWidth: 30, size: 'small' }}>
//                     {item.icon || <FolderIcon fontSize="small" />}
//                   </ListItemIcon>
//                   <ListItemText
//                     primaryTypographyProps={{ fontSize: "0.85rem", fontWeight: "bold" }}
//                     primary={item.title}
//                   />
//                 </ListItemButton>
//               ))}
//             </Box> */}

//             <Box sx={{ flexGrow: 1, overflowY: "auto" }}>

//               {filteredItems.map((item, index) => (
//                 <ListItemButton
//                   key={index}

//                   onClick={() => {
//                     setSelectedItem(item.title); // or item.path or item.id, depending on uniqueness
//                     if (item.submenu) {
//                       toggleMenu(item.title);
//                     } else {
//                       navigate(item.path);
//                     }
//                   }}

//                   // sx={{
//                   //   size: 'small',
//                   //   color: "#fff",
//                   //   padding: '1px',
//                   //   borderRadius: "6px",
//                   //   backgroundColor: selectedItem === item.title ? "#01579b" : "transparent",
//                   //   "&:hover": {
//                   //     backgroundColor: "#01579b",
//                   //   },
//                   //   mx: 1.5,
//                   //   my: 0.5,
//                   // }}

//                   sx={{
//                     borderRadius: 1.5,
//                     mx: 1,
//                     my: 0.5,
//                     py: 1,
//                     px: 2,
//                     color: colors.grey[300],
//                     transition: 'all 0.2s ease',
//                     backgroundColor: selectedItem === item.title ? alpha(colors.primary[400], 0.2) : 'transparent',
//                     '&:hover': {
//                       backgroundColor: alpha(colors.primary[400], 0.15),
//                       transform: 'translateX(4px)'
//                     }
//                   }}
//                 >
//                   <ListItemIcon sx={{ color: "#9aa2c3", minWidth: 30, size: 'small' }}>
//                     {item.icon || <FolderIcon fontSize="small" />}
//                   </ListItemIcon>
//                   <ListItemText
//                     primaryTypographyProps={{ fontSize: "0.85rem", fontWeight: "bold" }}
//                     primary={item.title}
//                   />
//                 </ListItemButton>
//               ))}
//             </Box>



//             {/* Footer */}
//             {/* <Box sx={{ px: 2, py: 1 }}>
//               <Box
//                 sx={{
//                   backgroundColor: "#2a2d3e",
//                   borderRadius: "8px",
//                   padding: "8px 10px",
//                   fontSize: "0.8rem",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   cursor: "pointer",
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center" }}>
//                   <Box
//                     sx={{
//                       backgroundColor: "#ffd600",
//                       borderRadius: "4px",
//                       color: "#000",
//                       fontWeight: "bold",
//                       padding: "2px 6px",
//                       fontSize: "0.75rem",
//                       mr: 1,
//                     }}
//                   >
//                     Optrim
//                   </Box>
//                   Deckle Matching
//                 </Box>
//               </Box>
//             </Box> */}

//             <Box sx={{ p: 2, mt: 'auto' }}>
//               <Divider sx={{ backgroundColor: alpha(colors.primary[400], 0.3), mb: 1.5 }} />
//               <Box sx={{
//                 backgroundColor: alpha(colors.primary[400], 0.15),
//                 borderRadius: 2,
//                 p: 1.5,
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'space-between'
//               }}>
//                 <Typography variant="caption" color={colors.grey[400]}>
//                   Papyrus360 ERP
//                 </Typography>
//                 <IconButton size="small" sx={{ color: colors.primary[400] }}>
//                   <AddIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Box>
//           </>
//         ) : (
//           <Box sx={{ flexGrow: 1 }} />
//         )}

//         {/* Always Visible Toggle Button at Bottom */}
//         {hovered || contextOpen ? (
//           <Box sx={{ p: 1, display: "flex", justifyContent: "center" }}>
//             <IconButton
//               onClick={() => setContextOpen((prev) => !prev)}
//               sx={{
//                 color: "#fff",
//                 bgcolor: "#2b2f42",
//                 "&:hover": { bgcolor: "#3a3f56" },
//                 borderRadius: "50%",
//                 boxShadow: 2,
//               }}
//             >
//               {hovered || contextOpen ? (
//                 <ChevronLeftIcon fontSize="small" sx={{ fontSize: '10px' }} />
//               ) : (
//                 // null
//                 <ChevronRightIcon fontSize="small" sx={{ fontSize: '10px' }} />
//               )}
//             </IconButton>
//           </Box>
//         ) : (
//           // null
//           <ChevronRightIcon fontSize="small" sx={{ fontSize: '10px' }} />
//         )}

//       </Box>
//     </Box>
//   );
// }